export enum VoiceSessionStatus {
  ACTIVE = 'ACTIVE',
  CONNECTING = 'CONNECTING',
  DISCONNECTED = 'DISCONNECTED',
  DISCONNECTING = 'DISCONNECTING',
}
